var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation } from '@apollo/client';
import { UpdateEsigningRecipientDocument } from './mutation.gql';
import { useEsigningProviderMetadata } from '../useEsigningProviderMetadata';
export const useUpdateEsigningRecipient = () => {
    const { properties } = useEsigningProviderMetadata();
    const { nameFormat } = properties;
    const [mutate, state] = useMutation(UpdateEsigningRecipientDocument);
    const updateRecipient = (props) => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        const { variables, onSuccess, onError } = props;
        // We need to remove the incorrect name format from the
        // variables, depending on what provider is connected
        if (nameFormat === 'firstNameLastName') {
            variables.input.name = undefined;
        }
        else {
            variables.input.firstName = undefined;
            variables.input.lastName = undefined;
        }
        try {
            const { data } = yield mutate({ variables });
            // eslint-disable-next-line no-underscore-dangle
            switch ((_a = data === null || data === void 0 ? void 0 : data.updateEsigningRecipient) === null || _a === void 0 ? void 0 : _a.__typename) {
                case 'UpdateEsigningRecipientPayload':
                    onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(data.updateEsigningRecipient);
                    break;
                case 'UpdateEsigningRecipientRejectionList':
                    onError === null || onError === void 0 ? void 0 : onError({ type: 'rejection', reason: data.updateEsigningRecipient.rejections[0].reason });
                    break;
                default:
                    throw new Error();
            }
        }
        catch (e) {
            onError === null || onError === void 0 ? void 0 : onError({ type: 'error', error: e });
        }
    });
    return [updateRecipient, state];
};
